export default __webpack_public_path__ + "static/media/gallery - potions_08.c7204707.jpg";